import React from 'react';
import { Input, CustomInput } from 'reactstrap';

export const Filter = ({ column }) => {
  return (
    <div style={{ marginTop: 5 }}>
      {column.canFilter && column.render('Filter')}
    </div>
  );
};

export const DefaultColumnFilter = ({
  column: {
    filterValue,
    setFilter,
    preFilteredRows: { length },
  },
}) => {
  return (
    <Input
      value={filterValue || ''}
      onChange={(e) => {
        setFilter(e.target.value || undefined);
      }}
      placeholder={`search (${length}) ...`}
    />
  );
};

export const SelectColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const options = React.useMemo(() => {
    const options = new Set();
    preFilteredRows.forEach((row) => {
      options.add(row.values[id]);
    });
    return [...options.values()];
  }, [id, preFilteredRows]);

  return (
    <CustomInput
      id='custom-select'
      type='select'
      value={filterValue}
      onChange={(e) => {
        setFilter(e.target.value || undefined);
      }}
    >
      <option value=''>All</option>
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </CustomInput>
  );
};

export const CheckAttributTaskForSearch = (term, task) => {
  var nom = task.assigne ? `${task.assigne.prenom} ${task.assigne.nom}` : "";

  return task.debut
    .toString()
    .toLowerCase()
    .includes(term.toLowerCase()) ||
    task.fin
      .toString()
      .toLowerCase()
      .includes(term.toLowerCase()) ||
    task.description.toLowerCase().includes(term.toLowerCase()) ||
    task.libelle.toLowerCase().includes(term.toLowerCase()) ||
    nom.toLowerCase().includes(term.toLowerCase())
    ? true
    : false;
};
